import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../interceptors/PublicInterceptor";

// OBTENER TODAS LAS CURRENCY
export const ObtenerCurrency = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/Currency`, "GET");
  return respuesta;
};

export const getPublicCurrency = async (token) => {
  const respuesta = await PublicInterceptor('Base/Global/Currency/tok', 'GET',undefined, token);
  return respuesta;
}

// AGREGAR CURRENCY
export const addCurrency = async (data) => {
  const respuesta = await PrivateInterceptor(
    `Base/Global/Currency/add`,
    "POST",
    data
  );
  return respuesta;
};


